import { render, staticRenderFns } from "./appointmentTracker.vue?vue&type=template&id=3163dffc&scoped=true&"
import script from "./appointmentTracker.vue?vue&type=script&lang=js&"
export * from "./appointmentTracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3163dffc",
  null
  
)

export default component.exports